module.exports = __webpack_public_path__ + "assets/img/15.58a07dd5.png";